import a665 from "@/assets/inspector-665.webp.asset.json";
import a1000 from "@/assets/inspector-1000.webp.asset.json";
import a1330 from "@/assets/inspector-1330.webp.asset.json";

export const inspectorImg = {
  src: a1000.url,
  srcSet: `${a665.url} 665w, ${a1000.url} 1000w, ${a1330.url} 1330w`,
  sizes: "(min-width: 1024px) 50vw, 100vw",
  width: 1330,
  height: 748,
};
